(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/info-item.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/info-item.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const InfoItem = _ref => {
  let {
    bold,
    icon,
    label
  } = _ref;
  const classList = ['bingo-info-item'];
  if (bold) {
    classList.push('bingo-info-item--bold');
  }
  return React.createElement("div", {
    className: classList.join(' ')
  }, React.createElement(Icon, {
    className: "bingo-info-item__icon",
    icon: icon
  }), React.createElement("p", {
    className: "bingo-info-item__label"
  }, label));
};
setGlobal('svs.bingo_react.components.bingoCard.InfoItem', InfoItem);

 })(window);